var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormula1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6736_1787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9549 4.82812C12.1127 4.82812 12.2084 4.92953 12.2479 5.13798C12.2873 5.3408 12.2873 5.57179 12.2648 5.83094C12.2366 6.0901 12.1972 6.34362 12.1465 6.58587C12.0958 6.83376 12.0563 6.9915 12.0338 7.06474H5.84789L5.5662 7.91545H10.062C10.0169 8.05066 9.93239 8.24784 9.80282 8.507C9.67324 8.76615 9.52113 9.02531 9.36338 9.27883C9.2 9.53798 9.04225 9.76334 8.88451 9.95489C8.72676 10.1521 8.60282 10.2478 8.50704 10.2478H4.70423L3.75775 13.1662H0L2.71549 4.82812H11.9606H11.9549Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9992 5.91602L15.6499 13.1724H12.433L14.1513 7.88785H12.3203C12.54 7.57235 12.7766 7.25123 13.0302 6.92447C13.2837 6.59771 13.5879 6.25968 13.9428 5.91602H17.9992Z",
    fill: "#8C8989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6736_1787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 8.34366,
    fill: "white",
    transform: "translate(0 4.82812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormula1);
export default __webpack_public_path__ + "static/media/Formula_1.54f96947eec6f571c69e4bea390fd743.svg";
export { ForwardRef as ReactComponent };